module.exports = __webpack_public_path__ + "ico-crypto-sand.svg?726bbf44bd84cc2daa0ca92d151b3eb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-sand.svg
// module id = 1154
// module chunks = 2